import {
	FormControlLabel,
	FormGroup,
	Grid,
	InputLabel,
	Stack,
	styled,
	Typography,
} from "@mui/material";
// import FormHelperText from '@mui/material/FormHelperText';
import FormControl from "@mui/material/FormControl";
// import InputLabel from '@mui/material/InputLabel';
import MenuItem from "@mui/material/MenuItem";
// import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { api } from "api";
import { outMetrics, RealmsTopic, RoleType } from "api/types";
import { IOSSwitch } from "components/SwitchButton/SwitchButton";
// import InputBase from "@mui/material/InputBase";
// import IconButton from "@mui/material/IconButton";
// import SearchIcon from "@mui/icons-material/Search";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { DownloadDialog } from "../../components/DownloadDialog/DownloadDialog";
import { useAuthStatus } from "../../helpers/useAuthStatus";
import { ActivityCount } from "./Component/ActivityCount";
import { CompletionRate } from "./Component/CompletionRate";
import { EnrollmentDistribution } from "./Component/EnrollmentDistribution";
import { YearLevel } from "./Component/YearLevel";
import { RealmSelectBar } from "./RealmSelect";
// import { TopicSelectBar } from "./TopicSelect";
let apiResponse: outMetrics;
const PREFIX = "ParentMetricsPage";

const classes = {
	root: `${PREFIX}-root`,
	button: `${PREFIX}-button`,
	title: `${PREFIX}-title`,
	groupList: `${PREFIX}-groupList`,
	summaryCard: `${PREFIX}-summaryCard`,
	summaryTitle: `${PREFIX}-summaryTitle`,
	summaryText: `${PREFIX}-summaryText`,
	icon: `${PREFIX}-icon`,
	bluePaper: `${PREFIX}-bluePaper`,
	Card: `${PREFIX}-Card`,
};

const Root = styled("div")(({ theme }) => ({
	[`&.${classes.root}`]: {
		padding: 20,
	},
	[`& .${classes.summaryCard}`]: {
		marginTop: 30,
		minHeight: 370,
		padding: theme.spacing(2),
		minWidth: 200,
		marginRight: theme.spacing(4),
	},
	[`& .${classes.Card}`]: {
		marginTop: 30,
		minHeight: 80,
		padding: theme.spacing(2),
		minWidth: 200,
		marginRight: theme.spacing(4),
	},
	[`& .${classes.bluePaper}`]: {
		marginTop: 30,
		minHeight: 80,
		padding: theme.spacing(2),
		minWidth: 200,
		marginRight: theme.spacing(4),
		backgroundColor: theme.palette.primary.main,
	},
}));

export const ParentMetricsPage = (props: {
	setLoading: any;
	uuid: string;
}): JSX.Element => {
	const { setLoading, uuid } = props;
	const { role } = useAuthStatus();
	const lastrealm = React.useRef<string[]>([]);
	const [recent, setRecent] = React.useState("All");
	const [rate, setRate] = useState([50]);
	const [month, setMonth] = useState([""]);
	const [activity, setActivity] = useState([{}]);
	const [yearlevel, setYearlevel] = useState(0);
	const [yearlevelArray, setYearlevelArray] = useState([0]);
	const [fetch, setFetch] = useState(false);
	const [startMonth, setStartMonth] = useState(1);
	const [startyear, setStartYear] = useState(1970);
	const [topic, setTopic] = useState(false);
	const [realm, setRealm] = useState<string[]>([
		"E=MC Square",
		"Cape Cosmos",
		"Green Acres",
		"Prehistoric Point",
		"Edison's Isle",
		"Elixir Institute",
		"DNAtion",
		"Fahren Heights",
		"Pythagoras Peninsula",
		"Habiterra",
	]);

	const [imgUrlMap, setImgUrlMap] = useState(new Map<string, string>());
	const handleSwitch = (): void => {
		setTopic(topic ? false : true);
		const convert_: string[] = [];
		for (const item of realm) {
			convert_.push(RealmsTopic[item]!);
		}
		setRealm(convert_);
	};

	const handleRecentChange = (event: SelectChangeEvent): void => {
		const d = new Date();
		let month_num = d.getMonth();
		let year = d.getFullYear();
		switch (event.target.value) {
			case "One Month":
				[year, month_num] = calculateDate(year, month_num + 1, 1);
				setStartMonth(month_num);
				setStartYear(year);
				handleResult(apiResponse, month_num, year);
				break;
			case "Three Month":
				[year, month_num] = calculateDate(year, month_num + 1, 3);
				setStartMonth(month_num);
				setStartYear(year);
				handleResult(apiResponse, month_num, year);
				break;
			case "One Year":
				[year, month_num] = calculateDate(year, month_num + 1, 12);
				setStartMonth(month_num);
				setStartYear(year);
				handleResult(apiResponse, month_num, year);
				break;
			default:
				handleResult(apiResponse, 1, 1970);
				break;
		}
		setRecent(event.target.value);
	};

	const calculateDate = (
		year_now: number,
		month_now: number,
		time_span: number,
	): [number, number] => {
		if (month_now - time_span <= 0) {
			year_now -= 1;
			month_now += 12;
			month_now -= time_span;
		} else {
			month_now -= time_span;
		}
		return [year_now, month_now];
	};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const handleResult = (
		res: outMetrics,
		month_num: number,
		year: number,
	): void => {
		// eslint-disable-next-line array-callback-return
		const filter_res = res.MetricsList.filter(function (a) {
			if (a.Year > year) {
				return true;
			} else if (a.Year === year && a.Month_num >= month_num) {
				return true;
			} else {
				return false;
			}
		});

		setRate(filter_res.map((a) => a.CompleteRate * 100));
		setMonth(filter_res.map((a) => a.Month));

		const MonthlyData = filter_res.map((a) => a.MonthlyDataList);
		const ActivityArray = [];
		let Realm: string[] = [];
		if (topic) {
			for (const item of realm) {
				Realm.push(RealmsTopic[item]!);
			}
		} else {
			Realm = realm;
		}
		for (let item of MonthlyData) {
			item = item.filter(function (a) {
				if (Realm.includes(a.LearningArea)) {
					return true;
				} else {
					return false;
				}
			});
			ActivityArray.push(
				Object.assign(
					{},
					...item.map((x) => ({ [x.LearningArea]: x.Activity })),
				),
			);
		}

		const Yearlevel_ = [];
		for (let item of MonthlyData) {
			item = item.filter(function (a) {
				if (Realm.includes(a.LearningArea)) {
					return true;
				} else {
					return false;
				}
			});
			Yearlevel_.push(
				Object.assign(
					{},
					...item.map((x) => ({ [x.LearningArea]: x.YearLevel })),
				),
			);
		}

		setActivity(ActivityArray);
		if (!(filter_res[0] === undefined)) {
			setYearlevel(filter_res[0].YearLevel);
		}
		setYearlevelArray(Yearlevel_[Yearlevel_.length - 1]);
	};

	const fetchResult = useCallback(() => {
		// no userId given
		// need to retrieve it via /people/me first
		if (uuid !== "") {
			if (window.sessionStorage.getItem(uuid) === null) {
				api
					.getIndividualMetrics(uuid)
					.then((res) => {
						if (res.status !== 200) {
							throw new Error();
						}
						window.sessionStorage.setItem(uuid, JSON.stringify(res.data));
						apiResponse = res.data;
						handleResult(apiResponse, 1, 1970);
						setFetch(true);
						setLoading(false);
					})
					.catch(() => {});
			} else {
				const Storage = window.sessionStorage.getItem(uuid);
				if (Storage !== null) {
					apiResponse = JSON.parse(Storage);
				}
				handleResult(apiResponse, 1, 1970);
				setFetch(true);
				setLoading(false);
			}
		}
	}, [handleResult, setLoading, uuid]);

	useEffect(() => {
		fetchResult();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uuid]);

	useEffect(() => {
		if (fetch && realm !== lastrealm.current) {
			lastrealm.current = realm;
			handleResult(apiResponse, startMonth, startyear);
		}
	}, [fetch, handleResult, realm, startMonth, startyear]);

	const onDownload = (urls: [string, string]): void => {
		imgUrlMap.set(urls[0], urls[1]);
		setImgUrlMap(imgUrlMap);
	};

	return (
		<Root className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper className={classes.bluePaper}>
						<Stack direction="row" justifyContent="space-between">
							<Stack direction="row" spacing={10}>
								<Paper
									component="form"
									sx={{
										p: "2px 4px",
										display: "flex",
										alignItems: "center",
										minwidth: 200,
									}}
								>
									{/* <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DateRangePicker
										startText="Start Date"
										endText="End Date"
										value={value}
										onChange={(newValue) => {
											setValue(newValue);
										}}
										renderInput={(startProps, endProps) => (
											<React.Fragment>
												<TextField {...startProps} />
												<Box sx={{ mx: 2 }}> - </Box>
												<TextField {...endProps} />
											</React.Fragment>
										)}
									/>
								</LocalizationProvider> */}
									<FormControl sx={{ m: 1, minWidth: 200 }}>
										<InputLabel id="period-select-label">
											Select a Period
										</InputLabel>
										<Select
											value={recent}
											onChange={handleRecentChange}
											labelId="period-select-label"
											label="Select a Period"
											defaultValue="All"
											// displayEmpty
											// inputProps={{ "aria-label": "Without label" }}
										>
											<MenuItem value="All">All</MenuItem>
											<MenuItem value="One Month">Recent One Month</MenuItem>
											<MenuItem value="Three Month">
												Recent Three Months
											</MenuItem>
											<MenuItem value="One Year">Recent One Year</MenuItem>
										</Select>
									</FormControl>
								</Paper>
								<FormGroup>
									<Stack direction="row" spacing={1} alignItems="center">
										<Typography color="common.white">Realm</Typography>
										<FormControlLabel
											control={<IOSSwitch sx={{ m: 1 }} />}
											label=""
											onChange={handleSwitch}
										/>
										<Typography color="common.white">Topic</Typography>
									</Stack>
								</FormGroup>
							</Stack>
							<Stack direction="row" alignItems="flex-start">
								<DownloadDialog
									role={role as RoleType}
									loading={false}
									baseName={"Metrics Results"}
									resultToBeRendered={{
										imageURLs: imgUrlMap,
									}}
									templateType={"metrics"}
								/>
							</Stack>
						</Stack>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Paper className={classes.Card}>
						<RealmSelectBar realm={realm} setRealm={setRealm} Topic={topic} />
					</Paper>
				</Grid>
				<Grid item xs={7}>
					<Paper className={classes.summaryCard}>
						<ActivityCount
							value={activity}
							month={month}
							topic={topic}
							onDownload={onDownload}
						/>
					</Paper>
				</Grid>
				<Grid item xs={5}>
					<Paper className={classes.summaryCard}>
						<EnrollmentDistribution
							value={activity}
							topic={topic}
							onDownload={onDownload}
						/>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Paper className={classes.summaryCard}>
						<CompletionRate
							value={rate}
							month={month}
							onDownload={onDownload}
						/>
					</Paper>
				</Grid>

				<Grid item xs={12}>
					<Paper className={classes.summaryCard}>
						<YearLevel
							value={yearlevelArray}
							yearlevel={yearlevel}
							topic={topic}
							onDownload={onDownload}
						/>
					</Paper>
				</Grid>
			</Grid>
		</Root>
	);
};
